
import { memo } from "react";
import { Link } from "react-router-dom";
import { NavItems } from "@/components/NavItems";
import { ThemeToggle } from "@/components/ThemeToggle";
import { AuthButtons } from "@/components/AuthButtons";
import { MobileMenu } from "@/components/MobileMenu";
import { NavMetalPuritySelector } from "@/components/NavMetalPuritySelector";
import { useAuth } from "@/hooks/useAuth";
import { useIsMobile } from "@/hooks/use-mobile";
import { useHydrationSafe } from "@/hooks/useHydrationSafe";
import { cn } from "@/lib/utils";

// Memoized components to prevent unnecessary re-renders during hydration
const MemoizedNavMetalPuritySelector = memo(NavMetalPuritySelector);
const MemoizedAuthButtons = memo(AuthButtons);
const MemoizedThemeToggle = memo(ThemeToggle);
const MemoizedMobileMenu = memo(MobileMenu);

export function MainNav() {
  const { isAuthenticated, role, loading } = useAuth();
  const isMobile = useIsMobile();
  const { isHydrated } = useHydrationSafe();
  
  return (
    <div className={cn(
      "main-nav-container z-50 border-b border-border/50 shadow-sm dark:border-border/30 transition-all duration-300",
      // Fixed su tutti i breakpoint
      "fixed top-0 left-0 right-0",
      // Background con blur per leggibilità durante scroll
      "bg-background/95 backdrop-blur-sm supports-[backdrop-filter]:bg-background/80"
    )}>
      <div className="container mx-auto px-3 sm:px-4">
        <div className="flex h-16 items-center justify-between gap-2 py-2">
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-2">
              <span className="font-bold text-2xl text-gold">Gildy</span>
            </Link>
          </div>
          
          {/* Desktop navigation - CSS hides below 1024px, JS handles landscape */}
          <div className={cn(
            "mx-6 flex items-center space-x-4",
            "hidden lg:flex",
            isHydrated && isMobile && "!hidden"
          )}>
            <NavItems 
              isAuthenticated={isAuthenticated} 
              userRole={role}
            />
          </div>
          
          <div className="flex items-center space-x-4">
            {/* Desktop elements - CSS hides below 1024px, JS handles landscape */}
            <div className={cn(
              "flex items-center space-x-4",
              "hidden lg:flex",
              isHydrated && isMobile && "!hidden"
            )}>
              <MemoizedNavMetalPuritySelector />
              <MemoizedThemeToggle />
              <MemoizedAuthButtons />
            </div>
            
            {/* Mobile elements - visible below 1024px */}
            <div className={cn(
              "flex items-center space-x-1 sm:space-x-2",
              "lg:hidden",
              isHydrated && !isMobile && "!hidden"
            )}>
              {/* Ordine da sinistra: Accedi, ThemeToggle, Hamburger (estrema destra) */}
              <MemoizedAuthButtons />
              <div className="hidden min-[360px]:flex">
                <MemoizedThemeToggle />
              </div>
              <MemoizedMobileMenu />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
